import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { normalizeDescription } from 'seagull/utils/richText';
/** easily connects an input ref and its error validation */ export const connectControllerToTextField = (props, options)=>{
    const _props_field = props.field, { ref } = _props_field, rest = _object_without_properties(_props_field, [
        "ref"
    ]);
    const { showErrors, errorMsg } = genericConnector(props, options);
    return _object_spread({
        inputRef: ref,
        error: showErrors,
        helperText: errorMsg
    }, rest);
};
export const connectControllerToKeyboardDatePicker = (props, options)=>{
    const { value, onChange } = props.field;
    const { showErrors, errorMsg } = genericConnector(props, options);
    return {
        value,
        onChange,
        error: showErrors,
        helperText: errorMsg
    };
};
export const connectControllerToAutocomplete = (props, options)=>{
    const { value, name, ref, onBlur, onChange } = props.field;
    const { showErrors, errorMsg } = genericConnector(props, options);
    return {
        inputValue: value,
        textFieldProps: {
            name,
            error: showErrors,
            helperText: errorMsg,
            inputRef: ref,
            label: options === null || options === void 0 ? void 0 : options.label,
            placeholder: options === null || options === void 0 ? void 0 : options.placeholder
        },
        onBlur,
        onInputChange: onChange
    };
};
export const connectControllerToDiscountTextField = (props, options)=>{
    const _props_field = props.field, { ref, onChange } = _props_field, rest = _object_without_properties(_props_field, [
        "ref",
        "onChange"
    ]);
    const { showErrors, errorMsg } = genericConnector(props, options);
    return _object_spread({
        inputRef: ref,
        error: showErrors,
        helperText: errorMsg,
        onChange: (value)=>onChange({
                target: {
                    value
                }
            })
    }, rest);
};
/** easily connects a RichTextEditor to a Controller */ export const connectControllerToRichTextEditor = (props, options)=>{
    const _props_field = props.field, { ref, onChange, value } = _props_field, rest = _object_without_properties(_props_field, [
        "ref",
        "onChange",
        "value"
    ]);
    const { showErrors, errorMsg } = genericConnector(props, options);
    return _object_spread({
        initialValue: value,
        editorRef: ref,
        onChange: (v)=>onChange({
                target: {
                    value: normalizeDescription(v)
                }
            }),
        error: showErrors,
        helperText: errorMsg
    }, rest);
};
export function genericConnector(param) {
    let { fieldState, formState } = param, options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _fieldState_error;
    const { noHelperText, alwaysShowErrors } = options;
    const showErrors = alwaysShowErrors ? !!fieldState.error : getShouldShowFieldError(fieldState, formState);
    const errorMsg = noHelperText ? undefined : showErrors ? (_fieldState_error = fieldState.error) === null || _fieldState_error === void 0 ? void 0 : _fieldState_error.message : undefined;
    return {
        showErrors,
        errorMsg
    };
}
function getShouldShowFieldError(fieldState, formState) {
    return fieldState.error && (fieldState.isTouched || formState.isSubmitted);
}
export const rhfValidateToBottomSheet = (validate)=>(value)=>{
        const result = validate(value);
        const isValid = result === undefined || result === true;
        return {
            error: !isValid,
            helperText: typeof result === 'string' ? result : undefined
        };
    };
export const RHF_VARIABLE_PICKER_SET_VALUE_OPTIONS = {
    shouldValidate: true,
    shouldDirty: true,
    shouldTouch: true
};
